/**
 * 业务主题
 */
import { businessTreemapMarketLightParse } from './treemapMarketLight';

export const businessTreemapMarketLight = {
  name: 'business-treemap-market-light' as const,
  parsers: [businessTreemapMarketLightParse]
};
